import React, { memo } from "react";
import allVan from '../../assets/images/nisaan-urvaan.png'

const TotalFeeSection = ({subscriptionDetail}) => {
const {amount,total_fees} = subscriptionDetail || {};
  return (
    <div className="total_feeInfo_section mt-4">
      <div className="row align-items-center">
        <div className="col-sm-2">
            <img src={allVan} className="img-fluid" alt="" />
        </div>
        <div className="col-lg-7 text-center text-md-start">
          <h2>Total Amount Payable</h2>
          <h3>
            <strike className="me-2 text-dark">{total_fees} AED</strike>{amount} AED{" "}
            <span className="badge bg-green">{(parseFloat(total_fees-amount)/total_fees*100).toFixed(2)}% Off</span>
          </h3>
        </div>
      </div>
    </div>
  );
};

export default memo(TotalFeeSection);
